import type * as mapboxgl from 'mapbox-gl';
import type { Feature, Polygon } from 'geojson';
import { environment } from '../../../../environments/environment';
import { defaultOverlayState, ForestLayersController, OverlayState } from './forest-layers';
import { parseFeatureCollection } from './map-traces-geo.controller';
import { TracesGeometryLayerController } from './traces-geometry-layer';
import { WhispRiskLayerController } from './whisp-layer';
import { WhispDebugController, WhispDebugSource } from './whisp-debug.controller';

export class MapOverlaysController {
  private forest: ForestLayersController | null = null;
  private whispRisk: WhispRiskLayerController | null = null;
  private traces: TracesGeometryLayerController | null = null;

  readonly whispDebug: WhispDebugController;

  constructor(
    private readonly map: () => mapboxgl.Map | undefined,
    whispDebugSource: WhispDebugSource = { load: async () => null },
    public state: OverlayState = defaultOverlayState()
  ) {
    this.whispDebug = new WhispDebugController(map, whispDebugSource);
    this.whispDebug.setVisible(state.whispDebug);
  }

  attachForest(): void {
    const map = this.map();
    if (!map) return;
    this.forest = new ForestLayersController(map, environment.mapbox.accessToken);
    this.forest.attach();
    this.forest.apply(this.state);
  }

  attachWhispRisk(): void {
    const map = this.map();
    if (!map) return;
    this.whispRisk = new WhispRiskLayerController(map);
    this.whispRisk.attach();
  }

  apply(state: OverlayState): void {
    this.state = state;
    this.forest?.apply(state);
    this.whispRisk?.setVisible(state.whisp);
    this.whispDebug.setVisible(state.whispDebug);
  }

  showWhispRisk(features: Feature<Polygon>[]): void {
    this.whispRisk?.show(features);
  }

  showTracesGeometry(tracesGeoJson: string | null | undefined): void {
    const map = this.map();
    const geometry = parseFeatureCollection(tracesGeoJson);
    if (!map || !geometry) return;
    this.traces ??= new TracesGeometryLayerController(map as any);
    this.traces.show();
    this.traces.setData(geometry);
  }
}
